import { useTranslation } from 'react-i18next';
import { impactStats, features } from '@/mocks/homeData';

export default function ImpactSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100">
      {/* Stats Bar */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            {t('impact.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('impact.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {impactStats.map((stat) => (
            <div
              key={stat.id}
              className="text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/60"
            >
              <span className="text-2xl md:text-4xl font-bold font-heading text-accent-600">
                {stat.value}
              </span>
              <p className="mt-2 text-xs md:text-sm text-foreground-600">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 pb-14 md:pb-20">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            {t('features.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/60"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-accent-100 rounded-full mb-5">
                <i className={`${feature.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}